import { IncentiveCategory } from '@varo/graphql-schema-types';
import IncentiveScreen from 'features/incentive/screens/IncentiveScreen/IncentiveScreen';

export default function IncentivePage() {
  return <IncentiveScreen incentiveType={IncentiveCategory.Sweepstakes} />;
}
